import React, {useState, useEffect} from "react";
import {gPageView} from "../google-analytics";
import WelcomePanel from '../components/super-og/super-og-welcome';
import GameLobby from '../components/super-og/super-og-lobby';
import SetupPanel from '../components/super-og/super-og-setup'
import ResultPanel from '../components/super-og/super-og-result';
import AlertPanel from '../components/super-og/super-og-alert';
import GameClient from "../lib/game-client";
import {useConnection, useWallet} from "@solana/wallet-adapter-react";
import Toast from "../components/toast-control";
import SuperOgPanels from "../constants/super-og-panels";
import ClipLoader from 'react-spinners/ClipLoader';
import ShowRealPanel from "../components/super-og/super-og-show-reel";
import {useParams} from "react-router-dom";

function SuperOGGamePage(props) {
    const {id} = useParams();
    const {panel}  = useParams();
    const {frame} = useParams();
    const wallet = useWallet();
    const {connection} = useConnection();
    const [game, setGame] = useState(null);
    const [script, setScript] = useState(null);
    const [data, setData] = useState({panelId: SuperOgPanels.Welcome});
    const [challenges, setChallenges] = useState(null);
    const [myGames, setMyGames] = useState(null);
    const [alertState, setAlertState] = useState({
        open: false,
        message: '',
        severity: undefined,
    });
    const [loadingInProgress, setLoading] = useState(false);
    useEffect(async () => {
        gPageView('super-og');
        if (wallet) {
            await onGetAccountInfo();
        }
        if (data && !data.game && panel && id && parseInt(panel) !== data.panelId) {
            // need to load the game
            await onChangePanel(parseInt(panel), {game: await GameClient.fetchGameResult(id)});
        }
    }, [wallet, connection, data, game]);
    const onChangePanel = async (panelId, moreData) => {
        setLoading(true);

        if (panelId === SuperOgPanels.Lobby) {
            const wid = wallet.publicKey.toString();
            await setMyGames(await GameClient.getMySuperOGGames(wid));
            await setChallenges(await GameClient.getOpenSuperOGChallenges(wid));
        }
        if (panelId === SuperOgPanels.Results || panelId === SuperOgPanels.ShowReel || panelId === SuperOgPanels.ShowReelReplay) {
            const g = await GameClient.fetchGameResult(moreData.game.id);
            if (panelId === SuperOgPanels.ShowReel || panelId === SuperOgPanels.ShowReelReplay) {
                let frameOverride = null;
                if (frame) {
                    frameOverride = parseInt(frame);
                }
                await setScript(await GameClient.getShowReelFrames(g, wallet?.publicKey?.toString(), onChangePanel, frameOverride));
            } else {
                await setGame(g);
            }
        }
        setData({...data, panelId, ...moreData, walletPK: wallet?.publicKey?.toString()});
        setLoading(false);
    }
    const onGetAccountInfo = async () => {
        try {
            if (wallet && wallet.connected) {
                setAlertState({
                    open: false,
                    message: '',
                    severity: 'info',
                });
            } else {
                setAlertState({
                    open: true,
                    message: 'Please connect your wallet to see your chefs.',
                    severity: '',
                });
            }

        } catch (error) {
            let message = error.msg || 'Could not access your wallet. Please try again.';
            if (!error.msg) {
                if (error.message.indexOf('0x138')) {
                } else if (error.message.indexOf('0x137')) {
                    message = `SOLD OUT!`;
                } else if (error.message.indexOf('0x135')) {
                    message = `Insufficient funds to mint. Please fund your wallet.`;
                }
            }
            setAlertState({
                open: true,
                message,
                severity: 'danger',
            });
        } finally {
        }
    };
    const loading = (toggle) => {setLoading(toggle);}
    const renderStep = (panelId) => {
        if (wallet && wallet.connected) {
            if (!panelId && panel) {
                panelId = parseInt(panel);
            }
            switch (panelId) {
                case SuperOgPanels.Alert:
                    return  <AlertPanel onChangePanel={onChangePanel} data={data} loading={loading} setLoading={setLoading} />;
                case SuperOgPanels.Lobby:
                    return <GameLobby onChangePanel={onChangePanel} challenges={challenges} myGames={myGames} data={data} loading={loading} />;
                case SuperOgPanels.NewChallenge:
                    return <SetupPanel onChangePanel={onChangePanel} panelId={panelId} data={data} loading={loading} />;
                case SuperOgPanels.AcceptChallenge:
                    return <SetupPanel onChangePanel={onChangePanel} panelId={panelId} data={data} loading={loading} />;
                case SuperOgPanels.Results:
                    return <ResultPanel onChangePanel={onChangePanel} data={data} game={game} loading={loading} playerPK={wallet?.publicKey?.toString()} />
                case SuperOgPanels.ShowReel:
                    return <ShowRealPanel onChangePanel={onChangePanel} frames={script} loading={loading} playerPK={wallet?.publicKey?.toString()} />;
                case SuperOgPanels.ShowReelReplay:
                    return <ShowRealPanel onChangePanel={onChangePanel} frames={script} loading={loading} playerPK={wallet?.publicKey?.toString()} replay />;
                case SuperOgPanels.Welcome:
                default:
                    return <WelcomePanel onChangePanel={onChangePanel} loading={loading} wallet={wallet} />
            }
        } else {
            return <WelcomePanel onChangePanel={onChangePanel} loading={loading} wallet={wallet} />;
        }
    }
    return (
        <div id="super-og-game" className="panel">
            <div className="max-w-lg w-full">
                <Toast
                    open={alertState.open}
                    message={alertState.message}
                    severity={alertState.severity}
                    onClose={() => setAlertState({...alertState, open: false})}
                />
            </div>
            <div className="panel bg-home">
                <ClipLoader
                    color={'#fff'}
                    size={150}
                    loading={loadingInProgress}
                    cssOverride={{
                        position: 'absolute',
                    }}
                />
                {
                    renderStep(data?.panelId)
                }
            </div>
        </div>
    );
}

export default SuperOGGamePage;